import {Injectable} from "@angular/core"
import {Headers} from "@angular/http"
import {USER_SECRET_STORAGE} from "../constants/storage";
import {Observable} from "rxjs";
import {HTTP} from "@ionic-native/http";
import {StorageService} from "../services/storage.service";

@Injectable()
export class AuthorizedHttpClient {
  constructor(private http: HTTP, private storage: StorageService) {
  }

  post(url, data) {
    let headers = new Headers();
    return Observable.fromPromise(new Promise((resolve, reject) => {
      this.storage.get(USER_SECRET_STORAGE).then((credentials) => {
        if (credentials && credentials.verified) {
          headers.append("X-USER-SECRET", credentials.secret);
          headers.append("X-USER-PHONENUMBER", credentials.phonenumber);
        }
        resolve(this.http.post(url, data, headers));
      })
    }));
  }

}



// WEBPACK FOOTER //
// ./src/app/classes/authorized_http_client.ts